module.exports = __webpack_public_path__ + "aedbf993cdb300d0c05d0ee830b8004c.svg";